import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Clapperboard } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PublicFooter } from "@/components/PublicFooter";

// Lightweight shell for public legal/info pages (header + content + footer).
export const PublicPage = ({ title, overline, children, testid }) => {
  useEffect(() => {
    if (title) document.title = `${title} — Mas Tofa AI`;
  }, [title]);

  return (
    <div className="min-h-screen bg-slate-50" data-testid={testid}>
      <header className="sticky top-0 z-30 border-b border-slate-200 bg-white/80 backdrop-blur-xl">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-4">
          <Link to="/" className="flex items-center gap-3" data-testid="public-logo">
            <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-blue-600 text-white">
              <Clapperboard className="h-5 w-5" />
            </div>
            <div className="leading-tight">
              <p className="font-heading font-bold tracking-tight text-slate-900">Mas Tofa AI</p>
              <p className="text-[11px] text-slate-500">AI untuk Video Jualan</p>
            </div>
          </Link>
          <div className="flex items-center gap-3">
            <Link to="/masuk"><Button variant="ghost" className="text-slate-700 hover:bg-slate-100">Masuk</Button></Link>
            <Link to="/daftar"><Button className="rounded-full bg-blue-600 px-5 text-white hover:bg-blue-700">Mulai Gratis</Button></Link>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-5 py-16">
        {overline && <p className="text-xs font-semibold uppercase tracking-[0.2em] text-blue-600">{overline}</p>}
        <h1 className="mt-3 font-heading text-3xl font-bold tracking-tight text-slate-900 md:text-4xl">{title}</h1>
        <div className="prose-mastofa mt-8 space-y-6 text-slate-700">{children}</div>
      </main>

      <PublicFooter />
    </div>
  );
};

// Small helpers for consistent legal typography.
export const H2 = ({ children }) => (
  <h2 className="font-heading text-xl font-semibold text-slate-900">{children}</h2>
);
export const P = ({ children }) => <p className="leading-relaxed text-slate-600">{children}</p>;
export const UL = ({ items }) => (
  <ul className="list-disc space-y-1.5 pl-5 text-slate-600">
    {items.map((it, i) => <li key={i}>{it}</li>)}
  </ul>
);
